<template>
    <div class="row">
        <div class="col-md-12">
            <div class="page-breadcrumb d-flex justify-content-between"></div>
        </div>
        <div class="col-md-12">
            <div class="card">
                <div class="card-body" style="margin-bottom: 130px">
                    <div class="bgloading" v-show="isloading"><Loader></Loader></div>
                    <div class="row">
                        <div class="col-7">
                            <h2 class="page-title">{{ $t("lang.label_r_m") }}</h2>
                        </div>
                        <div class="col-5">
                            <input
                                type="text"
                                placeholder="Search"
                                v-model="search"
                                class="form-control search"
                            />
                            <br />
                        </div>
                        <table class="table table-hover" id="tableID">
                            <thead>
                                <tr>
                                    <th scope="col" style="width: 1px">Id</th>
                                    <th scope="col" style="width: 180px">
                                        {{ $t("lang.label_date") }} /
                                        {{ $t("lang.label_time") }}
                                    </th>
                                    <th scope="col" style="width: 100px">
                                        {{ $t("lang.label_fname") }}
                                    </th>
                                    <th scope="col" style="width: 100px">
                                        {{ $t("lang.label_lname") }}
                                    </th>
                                    <th scope="col" style="width: 150px">
                                        {{ $t("lang.msj_email") }}
                                    </th>
                                    <th scope="col" style="width: 80px">
                                        {{ $t("lang.label_telephone") }}
                                    </th>
                                    <th
                                        scope="col"
                                        style="width: 5px; text-align: center"
                                    >
                                        {{ $t("lang.label_numberG") }}
                                    </th>
                                    <th
                                        scope="col"
                                        style="width: 10px; text-align: center"
                                    >
                                        PDF
                                    </th>
                                    <!-- <th scope="col" style="width: 5px; text-align: center;">{{$t("lang.label_detail")}}</th> -->
                                    <th
                                        scope="col"
                                        style="width: 100px; text-align: center"
                                    >
                                        {{ $t("lang.msj_status") }}
                                    </th>
                                    <!-- <th scope="col" style="width: 10px; text-align: center;">{{$t("lang.label_del")}}</th> -->
                                </tr>
                            </thead>
                            <tbody v-if="count === 0">
                                <tr>
                                    <th colspan="10">
                                        <div style="text-align: center">SIN REGISTRO</div>
                                    </th>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr v-for="(i, index) in filterItems" :key="index">
                                    <td>{{ i.item }}</td>
                                    <td class="celldate">
                                        <datetime
                                            type="datetime"
                                            v-model="i.datetime"
                                            :format="{
                                                year: 'numeric',
                                                month: 'short',
                                                day: 'numeric',
                                                hour: 'numeric',
                                                minute: '2-digit',
                                            }"
                                            use12-hour
                                            value-zone="America/New_York"
                                            :input-class="'form-control date date' + i.id"
                                            :data-ref="'showdate' + i.id"
                                        >
                                            <template slot="button-cancel">
                                                Cancel
                                            </template>
                                            <template
                                                slot="button-confirm"
                                                slot-scope="scope"
                                            >
                                                <span v-if="scope.step === 'date'"
                                                    >Next
                                                    <i class="fas fa-arrow-right"></i
                                                ></span>
                                                <span v-else @click="editFecha(i, index)"
                                                    ><i class="fas fa-check-circle"></i>
                                                    OK</span
                                                >
                                            </template>
                                        </datetime>
                                        <div :class="'showdate showdate' + i.id"></div>
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            @change="editCamp(i, index)"
                                            :maxlength="100"
                                            v-model="i.firstname"
                                            class="custom_mini form-control editables"
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            @change="editCamp(i, index)"
                                            :maxlength="100"
                                            v-model="i.lastname"
                                            class="custom_mini form-control editables"
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            @change="editCamp(i, index)"
                                            :maxlength="100"
                                            v-model="i.email"
                                            class="custom_mini form-control editables"
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            @change="editCamp(i, index)"
                                            :maxlength="100"
                                            v-model="i.phone"
                                            class="custom_mini form-control editables"
                                        />
                                    </td>
                                    <td style="text-align: center">
                                        <input
                                            type="number"
                                            @change="editCamp(i, index)"
                                            max="100"
                                            min="1"
                                            v-model="i.cant_pers"
                                            class="custom_mini form-control editables"
                                            style="text-align: center; font-size: 16px"
                                        />
                                    </td>
                                    <td style="text-align: center">
                                        <button
                                            class="btn badge-default"
                                            @click="pdfReserve(i.id)"
                                        >
                                            <i class="fas fa-file-pdf"></i>
                                        </button>
                                    </td>
                                    <!-- <td style="text-align: center;">
                                <button v-if="i.note" type="button" title="Edit Notes" class="btn btn-warning" @click="detailReserve('',i)" style="padding: 0px 3px; font-size: 10px; height: 16px;">
                                    <i class="far fa-sticky-note"></i>
                                    <span class="textIcon" style="display: none;">&nbsp;Edit Note</span>
                                </button>
                                <button v-else type="button" title="Edit Notes" class="btn btn-secundary" style="padding: 0px 3px; font-size: 10px; height: 16px;">
                                    <i class="far fa-sticky-note"></i>
                                    <span class="textIcon" style="display: none;">&nbsp;Edit Note</span>
                                </button>                                                                                                
                            </td> -->
                                    <td style="text-align: center">
                                        <span
                                            class="cdropdown badge-warning"
                                            v-if="i.status === 0"
                                        >
                                            <button
                                                class="btnActionDashboard badge-warning"
                                                style="
                                                    background-color: inherit;
                                                    border: 0px solid #ccc !important;
                                                "
                                            >
                                                <span class="badge-warning">
                                                    {{ $t("lang.label_pending") }}
                                                </span>
                                            </button>
                                            <label>
                                                <input type="checkbox" />
                                                <ul>
                                                    <li
                                                        class="badge-warning"
                                                        @click="statusReserve(i.id, 0)"
                                                    >
                                                        {{ $t("lang.label_pending") }}
                                                    </li>
                                                    <li
                                                        class="badge-success"
                                                        @click="statusReserve(i.id, 1)"
                                                    >
                                                        {{ $t("lang.label_reserved") }}
                                                    </li>
                                                    <li
                                                        class="badge-danger"
                                                        @click="statusReserve(i.id, 2)"
                                                    >
                                                        {{ $t("lang.label_canceled") }}
                                                    </li>

                                                    <li
                                                        class="badge-info"
                                                        @click="statusReserve(i.id, 3)"
                                                    >
                                                        {{ $t("lang.label_complete") }}
                                                    </li>
                                                    <li
                                                        class="badge-danger"
                                                        @click="statusReserve(i.id, 4)"
                                                    >
                                                        {{ $t("lang.label_expire") }}
                                                    </li>
                                                </ul>
                                            </label>
                                        </span>
                                        <span
                                            class="cdropdown badge-success"
                                            v-if="i.status === 1"
                                        >
                                            <button
                                                class="btnActionDashboard badge-success"
                                                style="
                                                    background-color: inherit;
                                                    border: 0px solid #ccc !important;
                                                "
                                            >
                                                <span class="badge-success">
                                                    {{ $t("lang.label_reserved") }}
                                                </span>
                                            </button>
                                            <label>
                                                <input type="checkbox" />
                                                <ul>
                                                    <li
                                                        class="badge-success"
                                                        @click="statusReserve(i.id, 1)"
                                                    >
                                                        {{ $t("lang.label_reserved") }}
                                                    </li>
                                                    <li
                                                        class="badge-warning"
                                                        @click="statusReserve(i.id, 0)"
                                                    >
                                                        {{ $t("lang.label_pending") }}
                                                    </li>
                                                    <li
                                                        class="badge-danger"
                                                        @click="statusReserve(i.id, 2)"
                                                    >
                                                        {{ $t("lang.label_canceled") }}
                                                    </li>

                                                    <li
                                                        class="badge-info"
                                                        @click="statusReserve(i.id, 3)"
                                                    >
                                                        {{ $t("lang.label_complete") }}
                                                    </li>
                                                    <li
                                                        class="badge-danger"
                                                        @click="statusReserve(i.id, 4)"
                                                    >
                                                        {{ $t("lang.label_expire") }}
                                                    </li>
                                                </ul>
                                            </label>
                                        </span>
                                        <span
                                            class="cdropdown badge-danger"
                                            v-if="i.status === 2"
                                        >
                                            <button
                                                class="btnActionDashboard badge-danger"
                                                style="
                                                    background-color: inherit;
                                                    border: 0px solid #ccc !important;
                                                "
                                            >
                                                <span class="badge-danger">
                                                    {{ $t("lang.label_canceled") }}
                                                </span>
                                            </button>
                                            <label>
                                                <input type="checkbox" />
                                                <ul>
                                                    <li
                                                        class="badge-danger"
                                                        @click="statusReserve(i.id, 2)"
                                                    >
                                                        {{ $t("lang.label_canceled") }}
                                                    </li>
                                                    <li
                                                        class="badge-success"
                                                        @click="statusReserve(i.id, 1)"
                                                    >
                                                        {{ $t("lang.label_reserved") }}
                                                    </li>
                                                    <li
                                                        class="badge-warning"
                                                        @click="statusReserve(i.id, 0)"
                                                    >
                                                        {{ $t("lang.label_pending") }}
                                                    </li>

                                                    <li
                                                        class="badge-info"
                                                        @click="statusReserve(i.id, 3)"
                                                    >
                                                        {{ $t("lang.label_complete") }}
                                                    </li>
                                                    <li
                                                        class="badge-danger"
                                                        @click="statusReserve(i.id, 4)"
                                                    >
                                                        {{ $t("lang.label_expire") }}
                                                    </li>
                                                </ul>
                                            </label>
                                        </span>
                                        <span
                                            class="cdropdown badge-info"
                                            v-if="i.status === 3"
                                        >
                                            <button
                                                class="btnActionDashboard badge-info"
                                                style="
                                                    background-color: inherit;
                                                    border: 0px solid #ccc !important;
                                                "
                                            >
                                                <span class="badge-info">
                                                    {{ $t("lang.label_complete") }}
                                                </span>
                                            </button>
                                            <label>
                                                <input type="checkbox" />
                                                <ul>
                                                    <li
                                                        class="badge-info"
                                                        @click="statusReserve(i.id, 3)"
                                                    >
                                                        {{ $t("lang.label_complete") }}
                                                    </li>
                                                    <li
                                                        class="badge-danger"
                                                        @click="statusReserve(i.id, 2)"
                                                    >
                                                        {{ $t("lang.label_canceled") }}
                                                    </li>
                                                    <li
                                                        class="badge-success"
                                                        @click="statusReserve(i.id, 1)"
                                                    >
                                                        {{ $t("lang.label_reserved") }}
                                                    </li>
                                                    <li
                                                        class="badge-warning"
                                                        @click="statusReserve(i.id, 0)"
                                                    >
                                                        {{ $t("lang.label_pending") }}
                                                    </li>
                                                    <li
                                                        class="badge-danger"
                                                        @click="statusReserve(i.id, 4)"
                                                    >
                                                        {{ $t("lang.label_expire") }}
                                                    </li>
                                                </ul>
                                            </label>
                                        </span>

                                        <span
                                            class="cdropdown badge-danger"
                                            v-if="i.status === 4"
                                        >
                                            <button
                                                class="btnActionDashboard badge-danger"
                                                style="
                                                    background-color: inherit;
                                                    border: 0px solid #ccc !important;
                                                "
                                            >
                                                <span class="badge-danger">
                                                    {{ $t("lang.label_expire") }}
                                                </span>
                                            </button>
                                            <label>
                                                <input type="checkbox" />
                                                <ul>
                                                    <li
                                                        class="badge-danger"
                                                        @click="statusReserve(i.id, 4)"
                                                    >
                                                        {{ $t("lang.label_expire") }}
                                                    </li>
                                                    <li
                                                        class="badge-info"
                                                        @click="statusReserve(i.id, 3)"
                                                    >
                                                        {{ $t("lang.label_complete") }}
                                                    </li>
                                                    <li
                                                        class="badge-danger"
                                                        @click="statusReserve(i.id, 2)"
                                                    >
                                                        {{ $t("lang.label_canceled") }}
                                                    </li>
                                                    <li
                                                        class="badge-success"
                                                        @click="statusReserve(i.id, 1)"
                                                    >
                                                        {{ $t("lang.label_reserved") }}
                                                    </li>
                                                    <li
                                                        class="badge-warning"
                                                        @click="statusReserve(i.id, 0)"
                                                    >
                                                        {{ $t("lang.label_pending") }}
                                                    </li>
                                                </ul>
                                            </label>
                                        </span>
                                    </td>
                                    <!-- <td style="text-align: center;">
                                <button class="btn badge-danger" @click="delReserve(i.id)"><i class="fas fa-times"></i></button>        
                            </td>                             -->
                                </tr>
                                <tr v-if="filterItems.length === 0">
                                    <th colspan="10">
                                        <div style="text-align: center">SIN REGISTRO</div>
                                    </th>
                                </tr>
                            </tbody>
                        </table>
                        <ul
                            v-if="
                                pagination.total > pagination.per_page && content === false
                            "
                            class="pagination justify-content-center"
                            style="borde: 1px solid blue"
                        >
                            <li v-if="pagination.current_page !== 1" class="page-car">
                                <button
                                    class="page-link"
                                    aria-label="Previous"
                                    v-on:click.prevent="
                                        changePage(pagination.current_page - 1)
                                    "
                                >
                                    <span aria-hidden="true">«</span>
                                </button>
                            </li>
                            <li
                                v-for="(page, index) in pagesNumber"
                                :key="index"
                                class="page-car"
                                :class="{ active: page === pagination.current_page }"
                            >
                                <button
                                    class="page-link"
                                    v-on:click.prevent="changePage(page)"
                                >
                                    {{ page }}
                                </button>
                            </li>
                            <li
                                v-if="pagination.current_page !== pagination.last_page"
                                class="page-car"
                            >
                                <button
                                    class="page-link"
                                    aria-label="Next"
                                    v-on:click.prevent="
                                        changePage(pagination.current_page + 1)
                                    "
                                >
                                    <span aria-hidden="true">»</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <modal
            name="modal_reserve"
            height="auto"
            width="400px"
            :resizable="true"
            :adaptive="true"
            :scrollable="true"
            class="imgPreview"
            :reset="true"
            :min-height="400"
        >
            <div class="card-header">
                {{ $t("lang.label_r_m") }}
                <button
                    @click="closeModal"
                    class="closeIcon"
                    style="background-color: #b7b7b7"
                >
                    <span></span>
                </button>
            </div>
            <div class="card-body">
                <div v-if="ShowdataItem === false">
                    <component :is="SettingBox" :item="dataItem"></component>
                </div>
                <div v-else>
                    <label>Notes: {{ dataItem.note }}</label>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import Loader from "@/components/shared/Loader.vue";
import formReserve from "@/components/dimenu/reserve/form_reserve.vue";
import { mapGetters } from "vuex";
export default {
    name: "tableSpecials",
    components: {
        Loader,
        formReserve,
    },
    data() {
        return {
            id: 0,
            date: "",
            time: "",
            firstname: "",
            lastname: "",
            email: "",
            phone: "",
            cant_pers: 1,
            note: "",
            status: 0,
            datetime: "",

            dataItem: [],
            ShowdataItem: false,
            isloading: false,
            org_id: window.localuserdata,
            user_id: window.localAccountID,
            reserve: [],
            count: 0,
            search: "",
            content: false,
            query: "",
            // pagination: [],
            offset: 4,
            page: 1,
            pagination: {
                current_page: 1,
                per_page: 0,
            },
            SettingBox: "",
            idxEdit: 0,
            detectarCambios: false,
        };
    },
    created() {
        this.getReserve();
    },
    mounted() {
        document.styleSheets[0].addRule(
            ".form-control.date",
            "    opacity: 0 !important;position: absolute;top: 5px;z-index: 1;"
        );
    },
    methods: {
        editFecha(i, idx) {
            this.idxEdit = idx;
            // console.log('editFecha', this.idxEdit, i.datetime, i);
            let t = this;
            setTimeout(function () {
                t.editCamp(i, idx);
            }, 500);
        },
        editCamp(b, idx) {
            let fn = b.firstname.length;
            let ln = b.lastname.length;
            let ph = 0;
            let em = b.email.length;
            if (parseInt(b.phone) === 0) {
                ph = 0;
            } else {
                ph = b.phone.length;
            }
            // console.log('datetime',b.datetime, this.filterItems[idx].datetime);
            //debugger;
            let datetime = this.DateTime(b.datetime);
            this.detectarCambios = false;
            this.idxEdit = 0;
            if (fn === 0 || ln === 0 || ph === 0 || em === 0) {
                this.$swal({
                    title: "Error",
                    text: "It is Empty",
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonColor: "#3085d6",
                });
            } else {
                let data = {
                    id: b.id,
                    org_id: b.org_id,
                    user_id: b.user_id,
                    firstname: b.firstname,
                    lastname: b.lastname,
                    phone: b.phone,
                    email: b.email,
                    cant_pers: b.cant_pers,
                    note: b.note,
                    date: datetime[0],
                    time: datetime[1],
                    datetime: b.datetime,
                };
                console.log("send", data);
                let url = "/menu/editreserve";
                window.master
                    .post(url, data)
                    .then((response) => {
                        console.log(response.data);
                        let t = this;
                        setTimeout(function () {
                            t.getReserve();
                        }, 500);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        DateTime(datetime) {
            let ab = datetime.split("T");
            let fec = ab[0];
            let times = ab[1];
            let time = times.substr(-20, 8);
            let t = time.split(":");
            let h = parseInt(t[0]);
            let m = parseInt(t[1]);
            let s = parseInt(t[2]);
            if (s === 0) {
                s = "00";
            }
            if (m === 0) {
                m = "00";
            }
            let hms = h + ":" + m + ":" + s;
            let ds = this.selectDate("a", 0);
            let mes = ds[7];

            let x = fec.split("-");
            let year = parseInt(x[0]);
            let month = parseInt(x[1]);
            let day = parseInt(x[2]);
            let datexx = new Date(mes[month] + " " + day + ", " + year + " " + hms);
            let options = {
                hour: "numeric",
                minute: "numeric",
                hour12: true,
            };
            let timeString = datexx.toLocaleString("en-US", options);
            let dates = [fec, timeString];
            return dates;
        },
        pdfReserve(id) {
            window.open(window.urlmaster + "api/v2/menu/reserve/pdf/" + id, "_blank");
            // let url = '/menu/reserve/pdf/'+id;
            // window.master.get(url)
            // .then((response) => {
            //     console.log('get ',response.data)
            // })
        },
        detailReserve(i, u) {
            this.SettingBox = i;
            this.dataItem = u;
            this.ShowdataItem = true;
            this.$modal.show("modal_reserve");
        },
        closeModal() {
            this.ShowdataItem = false;
            this.$modal.hide("modal_reserve");
        },
        editReserve(i, u) {
            this.ShowdataItem = false;
            this.SettingBox = i;
            this.dataItem = u;
            this.$modal.show("modal_reserve");
        },
        delReserve(id) {
            this.$swal({
                title: window.lang2.label_del_reserve,
                text: window.lang2.msj_you_sure,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: window.lang2.msj_del_it,
            }).then((result) => {
                if (result.value) {
                    this.f.id = id;
                    let url = "/menu/delreserve";
                    window.master
                        .post(url, this.f)
                        .then((response) => {
                            console.log("del ", response.data);
                            this.getReserve();
                        })
                        .catch((error) => console.log(error));
                }
            });
        },
        statusReserve(id, st) {
            // this.isloading = true;
            let f = [];
            f.push({
                status: st,
                id: id,
                org_id: window.localuserdata,
                user_id: window.localAccountID,
            });
            let url = "/menu/statusreserve";
            // console.log(this.f.status)
            window.master
                .post(url, f)
                .then((response) => {
                    console.log("status ", response.data);
                    this.getReserve();
                })
                .catch((error) => {
                    this.isloading = false;
                });
        },
        getReserve() {
            this.isloading = true;
            let url = "/menu/reserve" + this.query;
            window.master
                .post(url, {
                    org_id: this.org_id,
                    user_id: this.user_id,
                })
                .then((response) => {
                    // console.log('get ',response.data)
                    let r = response.data.lista.data; //mostrar data
                    let dat = [];
                    let o = 1;
                    for (let i in r) {
                        dat.push({
                            item: o,
                            id: r[i].id,
                            user_id: r[i].user_id,
                            org_id: r[i].org_id,
                            cant_pers: r[i].cant_pers,
                            date: r[i].date,
                            dates: r[i].dates,
                            email: r[i].email,
                            firstname: r[i].firstname,
                            lastname: r[i].lastname,
                            note: r[i].note,
                            status: r[i].status,
                            phone: r[i].phone,
                            time: r[i].time,
                        });
                        o++;
                    }
                    this.reserve = this.formatDate(dat);
                    this.pagination = response.data.lista; //paginacion
                    // console.log('reserve ',this.reserve )
                    this.count = this.reserve.length;
                    this.result = this.formatDate(response.data.result);
                    this.isloading = false;
                })
                .catch((error) => {
                    this.isloading = false;
                });
        },
        formatDate(r) {
            let ds = this.selectDate("");
            let mes = ds[5];
            let dia = ds[4];
            let dat = [];
            for (const i in r) {
                let p = r[i].dates;
                let ab = p.split("-");
                let year = parseInt(ab[0]);
                let month = parseInt(ab[1]);
                let day = parseInt(ab[2]);
                let m = mes[month];
                let dy = this.numberDay(day, month, year);
                let d = dia[dy];
                let f = d + ", " + m + ", " + year;
                let pp = r[i].time;

                let abp = pp.substr(0, 5);
                let abpz = pp.substr(5, 2);

                let t = abp.split(":");
                let h = parseInt(t[0]);
                let mm = parseInt(t[1]);
                if (h < 10) {
                    if (abpz === "PM") {
                        h = h + 12;
                    } else {
                        h = "0" + h;
                    }
                }

                if (mm < 10) {
                    mm = "0" + mm;
                }
                let hms = h + ":" + mm + ":00";
                let datetime = r[i].dates + "T" + hms;
                dat.push({
                    item: r[i].item,
                    id: r[i].id,
                    user_id: r[i].user_id,
                    org_id: r[i].org_id,
                    cant_pers: r[i].cant_pers,
                    date: f,
                    dates: r[i].dates,
                    datetime: datetime,
                    email: r[i].email,
                    firstname: r[i].firstname,
                    lastname: r[i].lastname,
                    note: r[i].note,
                    status: r[i].status,
                    phone: r[i].phone,
                    time: r[i].time,
                });
            }
            return dat;
        },
        numberDay(day, month, year) {
            let k, o, fechaComoCadena, numeroDia, c, nombreDia, cs, dates;
            if (day > 9) {
                k = day;
            } else {
                k = "0" + day;
            }
            if (month > 9) {
                o = month;
            } else {
                o = "0" + month;
            }
            fechaComoCadena = year + "-" + o + "-" + k + " 01:00:00"; // día viernes
            numeroDia = new Date(fechaComoCadena).getDay();
            return numeroDia;
        },
        selectDate(a, b) {
            let ie;
            if (a === "") {
                ie = window.lang2.label_IE;
            } else {
                ie = b;
            }
            let dias = [];
            let mes = [];
            if (ie === 1) {
                dias = [
                    "LUNES",
                    "MARTES",
                    "MIÉRCOLES",
                    "JUEVES",
                    "VIERNES",
                    "SÁBADO",
                    "DOMINGO",
                ];
                mes = [
                    "ENERO",
                    "FEBRERO",
                    "MARZO",
                    "ABRIL",
                    "MAYO",
                    "JUNIO",
                    "JULIO",
                    "AGOSTO",
                    "SEPTIEMBRE",
                    "OCTUBRE",
                    "NOVIEMBRE",
                    "DICIEMBRE",
                ];
            } else {
                dias = [
                    "MONDAY",
                    "TUESDAY",
                    "WEDNESDAY",
                    "THURSDAY",
                    "FRIDAY",
                    "SATURDAY",
                    "SUNDAY",
                ];
                mes = [
                    "JANUARY",
                    "FEBRUARY",
                    "MARCH",
                    "APRIL",
                    "MAY",
                    "JUNE",
                    "JULY",
                    "AUGUST",
                    "SEPTEMBER",
                    "OCTOBER",
                    "NOVEMBER",
                    "DECEMBER",
                ];
            }
            let diaA = [];
            let mesA = [];
            let diaB = [];
            let mesB = [];
            let diaCC = [];
            let mesCC = [];
            for (let i in dias) {
                let diaa =
                    dias[i].charAt(0).toUpperCase() + dias[i].slice(1).toLowerCase();
                let diasa = diaa.substring(0, 2);
                diaA.push(diasa);

                let mesa = mes[i].charAt(0).toUpperCase() + mes[i].slice(1).toLowerCase();
                let mesesa = mesa.substring(0, 2);
                mesA.push(mesesa);

                let diab =
                    dias[i].charAt(0).toUpperCase() + dias[i].slice(1).toLowerCase();
                let diasb = diab.substring(0, 3);
                diaB.push(diasb);

                let mesb = mes[i].charAt(0).toUpperCase() + mes[i].slice(1).toLowerCase();
                let mesesb = mesb.substring(0, 3);
                mesB.push(mesesb);

                let diaC =
                    dias[i].charAt(0).toUpperCase() + dias[i].slice(1).toLowerCase();
                diaCC.push(diaC);

                let mesC = mes[i].charAt(0).toUpperCase() + mes[i].slice(1).toLowerCase();
                mesCC.push(mesC);
            }
            let data = [dias, mes, diaA, mesA, diaB, mesB, diaCC, mesCC];
            this.masterData = data;
            return data;
        },
        changePage(page) {
            this.page = page;
            this.pagination.current_page = page;
            this.query = "?page=" + page;
            this.getReserve();
        },
    },
    computed: {
        filterItems: function () {
            let self = this;
            if (this.search !== "") {
                self.content = true;
                return this.result.filter(function (item) {
                    if (
                        item.firstname &&
                        item.firstname.toLowerCase().indexOf(self.search.toLowerCase()) >=
                            0
                    ) {
                        return item;
                    } else if (
                        item.lastname &&
                        item.lastname.toLowerCase().indexOf(self.search.toLowerCase()) >=
                            0
                    ) {
                        return item;
                    } else if (
                        item.email &&
                        item.email.toLowerCase().indexOf(self.search.toLowerCase()) >= 0
                    ) {
                        return item;
                    } else if (
                        item.date &&
                        item.date.indexOf(self.search.toLowerCase()) >= 0
                    ) {
                        return item;
                    } else if (
                        item.time &&
                        item.time.indexOf(self.search.toLowerCase()) >= 0
                    ) {
                        return item;
                    } else if (
                        item.phone &&
                        item.phone.indexOf(self.search.toLowerCase()) >= 0
                    ) {
                        return item;
                    } else if (
                        item.cant_pers &&
                        item.cant_pers.indexOf(self.search.toLowerCase()) >= 0
                    ) {
                        return item;
                    }
                });
            } else {
                self.content = false;
                return this.reserve.filter(function (item) {
                    if (
                        item.firstname &&
                        item.firstname.toLowerCase().indexOf(self.search.toLowerCase()) >=
                            0
                    ) {
                        return item;
                    } else if (
                        item.lastname &&
                        item.lastname.toLowerCase().indexOf(self.search.toLowerCase()) >=
                            0
                    ) {
                        return item;
                    } else if (
                        item.email &&
                        item.email.toLowerCase().indexOf(self.search.toLowerCase()) >= 0
                    ) {
                        return item;
                    } else if (
                        item.date &&
                        item.date.indexOf(self.search.toLowerCase()) >= 0
                    ) {
                        return item;
                    } else if (
                        item.time &&
                        item.time.indexOf(self.search.toLowerCase()) >= 0
                    ) {
                        return item;
                    } else if (
                        item.phone &&
                        item.phone.indexOf(self.search.toLowerCase()) >= 0
                    ) {
                        return item;
                    } else if (
                        item.cant_pers &&
                        item.cant_pers.indexOf(self.search.toLowerCase()) >= 0
                    ) {
                        return item;
                    }
                });
            }
        },
        pagesNumber() {
            if (!this.pagination.to) {
                return [];
            }
            let from = this.pagination.current_page - this.offset;
            if (from < 1) {
                from = 1;
            }
            let to = from + this.offset * 2;
            if (to >= this.pagination.last_page) {
                to = this.pagination.last_page;
            }
            let pagesArray = [];
            for (let page = from; page <= to; page++) {
                pagesArray.push(page);
            }
            return pagesArray;
        },
        ...mapGetters(["get_reserve"]),
    },
    watch: {
        get_reserve: function () {
            console.log("get_reserve = ", this.get_reserve);
            if (this.get_reserve) {
                this.getReserve();
            }
        },
        detectarCambios: function () {
            if (this.detectarCambios) {
                let i = this.filterItems[this.idxEdit];
                console.log("enviando cambios datetime");
                console.log(i, this.idxEdit);
                this.editCamp(i, this.idxEdit);
            }
        },
        filterItems: function () {
            console.log("filterItems", this.filterItems);
            setTimeout(function () {
                let d = document.querySelectorAll(".form-control.date");
                for (let i in d) {
                    if (d.hasOwnProperty(i)) {
                        document.querySelectorAll(
                            "." + d[i].getAttribute("data-ref")
                        )[0].innerText = d[i].value;
                    }
                }
            }, 500);
        },
    },
};
</script>
<style lang="scss" scoped>
.form-control {
    text-transform: lowercase;
}
.form-control::first-letter {
    text-transform: uppercase;
}

.badge-warning {
    color: #fff !important;
}
.badge-warning:hover {
    color: black !important;
}
.badge-primary:hover {
    color: black !important;
}
.badge-danger:hover {
    color: black !important;
}
.badge-success:hover {
    color: black !important;
}
.badge-info:hover {
    color: black !important;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
input[type="number"] {
    -moz-appearance: textfield;
}
.form-control.editables {
    border: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    background: transparent;
    font-size: 12px;
    padding: 0;
}
.table tbody tr:hover {
    background-color: #f1ffff;
}
.table tbody tr td:hover {
    background-color: #fff;
}
.cdropdown {
    width: 100%;
}
.cdropdown ul li {
    text-align: left;
}
.pagination {
    margin: auto;
    .page-car {
        &.active {
            .page-link {
                background-color: #8b8b8c;
                color: #fff;
            }
        }
    }
}
.search {
    // border-color: grey !important;
}
.bgloading {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
}
.showdate {
    position: absolute;
    top: 12px;
    z-index: 0;
    text-transform: lowercase;
}
.showdate::first-letter {
    text-transform: uppercase;
}

td.celldate {
    position: relative;
}
.form-control {
    text-transform: lowercase;
}
</style>
